<template>
  <div class="basic-block block-uranaitv-base" :style="styles">
    <img v-if="targetInfo.uTV.deco" :src="targetInfo.uTV.deco" class="block-uranaitv-base__deco" alt="">
    <div class="content-wrap">
      <div class="block-uranaitv-base__inner">
        <div class="block-uranaitv-base__title">
          <img :src="targetInfo.uTV.counselorImage" :alt="targetInfo.name">
          <h2 v-html="targetInfo.uTV.lead"></h2>
        </div>
        <p class="block-uranaitv-base__lead">より深く自分の運命を知ることで、幸せはどんどん近づいてくる。</p>
        <!-- <div class="block-uranaitv-base__menu"> -->
          <!-- <img src="/static/img/recommend/lp/common/uTV/menu.png" class="block-uranaitv-base__menu-title" alt="menu"> -->
          <!--
          <div class="block-uranaitv-base__menu-head">その他人気占い師のメニュー</div>
          <ul class="block-uranaitv-base__menu-list">
            <li v-for="(v, i) in menu" :key="i">
              <img :src="v.url" alt="">
              <p v-html="v.description"></p>
            </li>
          </ul>
          -->

          <!--
          <div class="block-uranaitv-base__menu-head">{{targetInfo.mainMethod}}で占えるあなたのこと</div>
          <ul class="block-uranaitv-base__menu-list">
            <li v-for="(v, i) in targetInfo.menuDetails.contents" :key="i">
              <span class="wrap">
                <img :src="v.icon" alt="">
                <span v-html="v.description"></span>
              </span>
            </li>
          </ul>
          -->

        <!-- </div> -->

        <template v-if="isIndividualed">
          <div class="block-uranaitv-base__menu individualed">
            <div class="block-uranaitv-base__menu-head">{{targetInfo.mainMethod}}で占えるあなたのこと</div>
            <ul class="block-uranaitv-base__menu-list">
              <li v-for="(v, i) in targetInfo.menuDetails.contents" :key="i">
              <span class="wrap">
                <img :src="v.icon" alt="">
                <span v-html="v.description"></span>
              </span>
              </li>
            </ul>
          </div>
        </template>

        <template v-else>
          <div class="block-uranaitv-base__menu">
            <!-- <img src="/static/img/recommend/lp/common/uTV/menu.png" class="block-uranaitv-base__menu-title" alt="menu"> -->
            <div class="block-uranaitv-base__menu-head">その他人気占い師のメニュー</div>
            <ul class="block-uranaitv-base__menu-list">
              <li v-for="(v, i) in menu" :key="i">
                <img :src="v.url" alt="">
                <p v-html="v.description"></p>
              </li>
            </ul>
          </div>
        </template>

        <p class="block-uranaitv-base__copy">定額で好きなだけ占いが見られるコースなら、<br>様々なジャンルを含む<b>2000</b>メニューから<br>自分にぴったりなものが見つかる！</p>
        <!-- <img src="/static/img/recommend/lp/common/uTV/counselors.png" alt="" class="block-uranaitv-base__counselors"> -->
        <h3 class="block-uranaitv-base__point-copy">占いTV<br>月額528円（税込）</h3>
        <lp-base-button label="登録して占う" design="fill" :color-scheme="colorScheme" class="block-uranaitv-base__point-btn" @clicked="clicked(1)" />
      </div>
    </div>
  </div>
</template>

<script>
import {COLLECTION_ICONS} from '@/utvStore/components/recommend/lp/commons'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockUranaiTv',
  components: {
    LpBaseButton,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    /*
    isIndividualed: {
      type: Boolean,
      default: false,
    },
     */
    menuId: {
      type: Number,
      default: 0,
    },
    subscUrl: String,
    page: String,
    emphasisColor: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      /*
      menu: [
        'その恋が叶う必然性',
        '転職すれば、お給料は上がりますか？',
        '運命の出逢いはこんなかたち',
        'あなたの金運を掴む天職',
        '苦手なあの人とどう接したらいい？',
        'あなたの恋と仕事の最適バランス',
      ],
       */
      showToTop: false,
    }
  },
  computed:{
    isIndividualed() {
      return !!this.targetInfo.menuDetails
        && this.targetInfo.menuDetails.contents.length > 0
        && !this.targetInfo.menuDetails.noIndividualed
    },
    styles(){
      const mdColors = !!this.targetInfo.menuDetails ? this.targetInfo.menuDetails.colors : {
        headBg: '#142254',
        headColor: 'white',
        baseBg: '#fffbe3',
        baseColor: '#142254',
      }
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--md-head-bg': mdColors.headBg,
        '--md-head-col': mdColors.headColor,
        '--md-base-bg': mdColors.baseBg,
        '--md-base-col': mdColors.baseColor,
        '--emphasis-col': !!this.emphasisColor ? this.emphasisColor : this.colorScheme.second
      }
    },
    menu(){
      return COLLECTION_ICONS.filter(item => !!item).sort((a,b) => a.sort - b.sort)
    }
  },
  mounted() {
  },
  methods: {
    clicked(val) {
      const pageLabel = !!this.page && this.page.length > 0 ? this.page : ''
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}${pageLabel}-subsc-button`,
        'event_label': this.menuId > 1 ? this.menuId : 1
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_md_head_bg: var(--md-head-bg);
$l_col_md_head_col: var(--md-head-col);
$l_col_md_base_bg: var(--md-base-bg);
$l_col_md_base_col: var(--md-base-col);
$l_col_emphasis_col: var(--emphasis-col);

.block-uranaitv-base {
  background: #fff;
  position: relative;
  padding: 32px 0 80px;
  &__deco {
    position: absolute;
    top: -45px;
    left: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 2;
  }
  &__inner {
    padding: 0 20px;
  }
  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 28px;
    img {
      max-width: 85px;
      margin: 0 2px 0 0;
    }
    h2 {
      font-weight: bold;
      font-size: 26px;
      line-height: 26px;
      text-align: center;
      color: $l_col_keycolor;
    }
  }
  &__lead {
    font-size: 14px;
    line-height: 21px;
    text-align: justify;
    margin: 0 0 16px;
  }
  &__menu {
    background: #FFFBE3;
    border-radius: 10px;
    padding: 20px 20px 40px;
    margin: 0 0 24px;
    $par: &;
    &.individualed {
      border-radius: 10px;
      margin: 0 0 24px;
      overflow: hidden;
      padding: 0;
      #{$par}-head {
        text-align: center;
        color: $l_col_md_head_col;
        background: $l_col_md_head_bg;
        font-size: 18px;
        line-height: 26px;
        font-weight: bold;
        border-radius: 10px 10px 0 0;
        padding: 13px 0 11px;
        margin: 0;
      }
      #{$par}-list {
        margin: 0;
        padding: 16px 0 8px;
        list-style: none;
        background: $l_col_md_base_bg;
        li {
          display: block;
          margin-bottom: 16px;
          padding: 0 20px;
          .wrap {
            display: flex;
            align-items: center;
            padding-bottom: 16px;
            border-bottom: 1px solid #dadada;
            img {
              max-width: 50px;
              margin: 0 16px 0 0;
            }
            span {
              display: inline-block;
              font-weight: bold;
              font-size: 16px;
              line-height: 21px;
              color: $l_col_md_base_col;
              margin: 0;
            }
          }
          &:last-child {
            margin-bottom: 0;
            .wrap {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
  &__menu-title {
    max-width: 61px;
    display: block;
    margin: 0 auto 16px;
  }
  &__menu-head {
    text-align: center;
    color: white;
    background: $l_col_md_head_bg;
    font-size: 18px;
    line-height: 26px;
    margin: -20px -20px 16px;
    font-weight: bold;
    border-radius: 10px 10px 0 0;
    padding: 13px 0 11px;
  }
  &__menu-list {
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      display: flex;
      align-items: center;
      + li {
        margin-top: 8px;
      }
      img {
        max-width: 50px;
        margin: 0 16px 0 0;
      }
      p {
        font-weight: bold;
        font-size: 16px;
        line-height: 21px;
        color: $l_col_keycolor;
        margin: 0;
      }
    }
  }
  &__copy {
    font-weight: bold;
    font-size: 15px;
    line-height: 1.33;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 auto 48px;
    b {
      font-family: 'din 2014', sans-serif;
      font-weight: bold;
      font-size: 32px;
      color: $l_col_emphasis_col;
      vertical-align: -6px;
      letter-spacing: -1px;
    }
  }
  &__counselors {
    max-width: 100%;
    margin: 0 auto 40px;
  }
  &__point {
    position: relative;
    margin: 0 auto 40px;
  }
  &__point-point {
    position: relative;
    svg {}
    img {
      position: absolute;
      top: 11px;
      left: 23px;
    }
  }
  &__point-img {
    max-width: 100%;
    vertical-align: middle;
    margin: -30px 0 20px;
  }
  &__point-copy {
    font-weight: bold;
    font-size: 26px;
    line-height: 32px;
    text-align: center;
    margin: 0 0 20px;
    color: $l_col_keycolor;
  }
  &__point-text {
    font-weight: bold;
    font-size: 15px;
    line-height: 21px;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 24px;
  }
  &__point-btn {
    max-width: 270px;
    margin: auto;
  }
  &__benefit {
    background: #FFFBE3;
    padding: 36px 0 44px;
  }
  &__benefit-box {
    background: rgba(#FFFFFF, 0.75);
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    padding: 72px 24px 38px;
    margin: 0 auto 36px;
  }
  &__benefit-title {
    display: block;
    max-width: 100px;
    margin: 0 auto -50px;
  }
  &__tokuten {
    background: #FDD96C;
    padding: 5px 0;
    margin: 36px 17px 20px 29px;
    text-align: center;
    position: relative;
    font-weight: bold;
    font-size: 16px;
    &:first-of-type {
      margin-top: 0;
    }
    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 100%;
      width: 0;
      height: 0;
      border: 8.5px solid transparent;
    }
    &::before {
      top: 0;
      border-color: #FDD96C transparent transparent #FDD96C;
    }
    &::after {
      bottom: 0;
      border-color: transparent transparent #FDD96C #FDD96C;
    }
    img {
      position: absolute;
      top: -12px;
      left: -29px;
      width: 58px;
    }
  }
  &__tokuten-lead {
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    margin: 0 0 14px;
    > span {
      display: inline-block;
    }
  }
  &__tokuten-img {
    display: block;
    margin: 0 auto 20px;
    max-width: 100%;
    vertical-align: middle;
  }
  &__tokuten-text {
    font-size: 13px;
    line-height: 21px;
    text-align: justify;
    color: #656D78;
    margin: 0;
  }
  &__tokuten-btn {
    max-width: 270px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockUranaiTvShort.vue